import { useRef, useState } from "react";
import { Box, useToast } from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
import { useNavigate } from "react-router-dom";
import Form from "./Form";
import { postNewPackage } from "../../../actions/management.action";

const CreatePackages = () => {
  const [data, setData] = useState({
    packageTitle: "",
    uniqueCode: "",
    startLocation: "",
    endLocation: "",
    category: "",
    activity: "",
    tags: "",
    duration: "",
    packageType: "",
    pricingType: "",
    minTravellers: "",
    vehicleSegment: "",
    currency: "INR",
    amountWithoutStay: "",
    amountWithStay: "",
    promotion: "",
    promoStartDate: "",
    promoEndDate: "",
    surgePrice: "",
    surgeStartDate: "",
    surgeEndDate: "",
    productStatus: "draft",
    journey: "",
    image: "",
    inclusionsAndExclusions: "",
    cancellationPolicy: "",
    travellers: "",
    stops: [],
  });
  const [isSaving, setIsSaving] = useState(false);
  const formRef = useRef(null);
  const toast = useToast();
  const navigator = useNavigate();

  const handleSubmit = async (formData) => {
    console.log("Submitting payload:", formData);

    // Log all FormData entries for debugging
    console.log("FormData entries being sent:");
    for (let [key, value] of formData.entries()) {
      console.log(`  ${key}: ${value}`);
    }

    setIsSaving(true);
    try {
      let res = await postNewPackage(formData);
      if (res?.success) {
        toast({
          title: "Success",
          description: res?.message || "Package created successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        // Navigate to the package details page with the created package ID
        if (res?.data?._id) {
          navigator(`/management/packages/${res.data._id}`);
        } else {
          navigator("/management/packages");
        }
      }
    } catch (error) {
      console.error("Error creating package:", error);
      toast({
        title: "Error",
        description: error.message || "Failed to create package",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box p={8} minH="100vh">
      <BreadCrumbMaker
        items={[
          // { link: "/", title: "Dashboard" },
          { link: "/management", title: "Operations Setup" },
          { link: "/management/packages", title: "Packages" },
          {
            link: "/management/packages/create",
            title: "Create Package",
            on: true,
          },
        ]}
      />

      {/* Main Container */}
      <Box p={4} pt={0} boxShadow="sm">
        {/* Image Upload */}
        <Form
          data={data}
          setData={setData}
          handleSubmit={handleSubmit}
          formRef={formRef}
          isEditMode={false}
          isSaving={isSaving}
        />
      </Box>
    </Box>
  );
};

export default CreatePackages;
